import { createSelector } from 'reselect';
import { API_SCANNED_ATTENDEES } from '../constants/apiRoutes';

const scannedAttendees = (state, props) => state.scannedAttendees;
const scannedAttendeesIds = (state, props) => state.sortIds[API_SCANNED_ATTENDEES] || [];
const currentEventId = (state, props) => props.match.params.eventId;

export const selectScannedAttendees = createSelector(
  [scannedAttendees],
  scannedAttendees => {
    return scannedAttendees;
  }
);

export const selectScannedAttendeesIds = createSelector(
  [scannedAttendeesIds, currentEventId],
  (scannedAttendeesIds, eventId) => {
    // Filter IDs to only include those from the current event
    return scannedAttendeesIds
      .filter(item => item.parent_id === +eventId)
      .map(item => item.id);
  }
);
